import React from "react";
import Hero from "./Hero/Hero";
import Mission from "./Mission/Mission";
import Benefit from "./Benefit/Benefit";
import Auction from "./Auction/Auction";
import Category from "./Category/Category";

const LandingPage: React.FC = () => {
  return (
    <div className="LandingPage">
      <Hero />
      <Mission />
      <Benefit />
      <Category />
      <Auction />
    </div>
  );
};

export default LandingPage;
